import { render, staticRenderFns } from "./SavedContacts.vue?vue&type=template&id=49b5e820&"
import script from "./SavedContacts.vue?vue&type=script&lang=js&"
export * from "./SavedContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports